import { i18n } from "@/i18n";

export default {
  path: "/download-file/:action/:base64file/:fileName",
  name: "downloadFile",
  component: () => import(/* webpackChunkName: "download" */ "@/views/Download/DownloadView.vue"),
  meta: {
    authRequired: false,
    // Rendu hors du chrome interne (nav/header/footer), cf. App.vue::displayLayout() (point 5,
    // review MR !1617 — piloté par la route plutôt que par un nom en dur dans App.vue).
    bareLayout: true,
    title: i18n.global.t("page.download.title"),
    breadcrumb: true,
  },
};
